import React, {useEffect, useState} from 'react';
import * as cerahOnlineStyle from '../cerahOnline/cerahOnline.module.scss';
import * as style from './cerahKids.module.scss';
import {Language} from "../i18n/language";
import {CourseTypes} from "../wizardComponents/courseTypes/courseTypes";
import {ScrollTracker} from "../analytics/scrollTracker";
import {ageGroupEl, CerahKidsWizard} from "./cerahKidsWizard";
import Helmet from "next/head";
import {useFixedWinHeight} from "../main/main";
import {CerahKidsArticle} from './cerahKidsArticle';
import KidsBannerImg1 from "../../../img/cerahKids/speaking practice.webp";
import KidsTextBgdImg from "../../../img/cerahKids/cerah-kids-text-background.png";
import {WhyCerahSection} from '../main/whyCerah/whyCerah';
import {TestimonialsSection} from '../main/testimonials/testimonialsSection';
import {TryBeforeBuy, scrollTo} from '../cerahOnline/cerahOnline';
import DidYouKnow from "../../../img/cerahKids/did-you-know.webp";
import {Button} from "../controls/button";
import * as buttonStyle from "../controls/button.module.scss";
import EllipseLeft from "../../../img/main/ellipse-left.svg";
import EllipseCenter from "../../../img/main/ellipse-center.svg";
import EllipseRight from "../../../img/main/ellipse-right.svg";
import analytics from "../analytics/analytics";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {SectionTitle} from '../main/sectionTitle';
import {getTestimonials} from '../testimonialsPage/testimonials';
import KaelaLeekaImg from "../../../img/testimonials/kaela_leeka.jpg";
import QuotesImg from "../../../img/testimonials/testimonial-quote.svg";
import {experimentGroup} from '../experiment/experimentGroup';

const heroSectionElId = "kids-hero";
const didYouKnowSectionElId = "kids-did-you-know";
const descriptionSectionElId = "kids-perks";
const pricesSectionElId = "kids-price";
const testimonialsSectionElId = "kids-testimonial";
const TryBeforeBuySectionElId = "kids-try-before-buy";
const cerahKidsWizardElId = "cerah-kids-wizard";

const scrollableSections = [
  [heroSectionElId, "scrollToHero"],
  [didYouKnowSectionElId, "scrollToDidYouKnow"],
  [descriptionSectionElId, "scrollToPerks"],
  [pricesSectionElId, "scrollToPrice"],
  [testimonialsSectionElId, "scrollToTestimonialsSection"],
  [TryBeforeBuySectionElId, "scrollToTryBeforeBuy"],
  [ageGroupEl, "scrollToWizard"],
];

export function CerahKids() {
  const [showingWizard, setShowingWizard] = useState(false);

  let scrollTracker;

  useEffect(() => {
    scrollTracker = new ScrollTracker('kids', scrollableSections);
    scrollTracker.setup();
    return scrollTracker.teardown.bind(scrollTracker);
  }, []);

  const strings = Language.active.cerahKids;

  function showWizard() {
    analytics.track("kids.btnHeroTryNow");
    setShowingWizard(true);
    scrollTo(cerahKidsWizardElId);
  }

  const testimonialExperimentGroup = experimentGroup.getCerahKidsTestimonialGroup();

  return (
    <div className={`${cerahOnlineStyle.cerahOnline}`}>
      <Helmet>
        <title>{strings.pageTitle}</title>
        <meta name="description" content={strings.metaDescription}/>
      </Helmet>
  
      <div id={heroSectionElId} className={style.banner}>
        <div className={`${style.bannerInner}`}>
          <div className={style.bannerLeft}>
            <LazyLoadImage className={style.background} src={KidsTextBgdImg.src}/>
            <span className={style.bannerTitle}>
              {strings.startLearningEarly}
            </span>
            {strings.content.split('\n').map((para, idx) => (
              <span key={idx} className={style.bannerText}>
                {para}
              </span>
            ))}
            <div>
              <Button className={`${buttonStyle.large} `}
                      noArrow
                      onClick={showWizard}>
                {strings.tryItNow}
              </Button>
            </div>
          </div>
          <LazyLoadImage alt={strings.kidsImgAltText} className={style.heroImg} src={KidsBannerImg1.src}/>
        </div>
        <>
          <LazyLoadImage className={style.ellipseLeft} src={EllipseLeft.src}/>
          <LazyLoadImage className={style.ellipseCenter} src={EllipseCenter.src}/>
          <LazyLoadImage className={style.ellipseRight} src={EllipseRight.src}/>
        </>
      </div>

      <div id={didYouKnowSectionElId} className={style.didYouKnow}>
        <div className={style.didYouKnowInner}>
          <div className={style.imgContainer}>
            <LazyLoadImage className={style.img} src={DidYouKnow.src}/>
          </div>
          <div className={style.textContainer}>
            <span className={style.text}>{strings.didYouKnow.sixtyCountries}</span>
            <span className={style.text}>{strings.didYouKnow.broadenTheirHorizons}</span>
          </div>
        </div>
      </div>

      <div id={descriptionSectionElId} className={cerahOnlineStyle.section}>
        <WhyCerahSection/>
      </div>

      <div id={testimonialsSectionElId} className={cerahOnlineStyle.section}>
        {testimonialExperimentGroup === 1 &&
          <div className={style.kidsTestimonial}>
            <SectionTitle title={Language.active.whatTheySayAboutUs.whatTheySayAboutUs}/>
            <div className={style.row}>
              <div className={style.columnLeft}>
                <LazyLoadImage className={style.testimonialImage} src={KaelaLeekaImg.src}/>
              </div>
              <div className={style.columnRight}>
                <img className={style.quotes} src={QuotesImg.src}/>
                <span className={style.text}>{Language.active.testimonials.reviews.kaelaLeeka}</span>
                <span className={style.personName}>Kaela & Leeka</span>
                <span className={style.personInfo}>{strings.nineYearOldIndonesianStudents}</span>
              </div>
            </div>
          </div>
        }

      </div>

      <div id={pricesSectionElId} className={cerahOnlineStyle.section}>
        <CourseTypes kids={true}/>
      </div>
      
      <div id={TryBeforeBuySectionElId} className={cerahOnlineStyle.section}>
        <TryBeforeBuy title={strings.tryBeforeBuy.title} subTitle={strings.tryBeforeBuy.subTitle}/>
      </div>

      <div id={cerahKidsWizardElId}>
        <CerahKidsWizard/>
      </div>

      {/*{!showingWizard && <div className={cerahOnlineStyle.halfScreenSection}>*/}
      {/*  <CerahKidsArticle/>*/}
      {/*</div>}*/}
    </div>
  );
}

